import { getCookie } from "../api/cookie";

const reservedServer = getCookie('serverName')
export const serverName = reservedServer ? reservedServer.toLowerCase() : 'production'
const tapsiApi = 'https://api.tapsi.cab/api'
const stageServerApi = serverName === 'tapsi' || serverName === 'production' ?
  tapsiApi :
  `https://${serverName}.backyard.tapsi.tech/api`

export const serverStates = {
  local: { lnk: 'localhost', api: stageServerApi, url: '' },
  mobileDebugger: { lnk: '172.16', api: stageServerApi, url: '' },
  stage: { lnk: 'backyard', api: stageServerApi, url: 'https://web-beta.backyard.tapsi.tech' },
  release: { lnk: 'tapsi', api: tapsiApi, url: 'https://app.tapsi.cab' },
}

export default serverStates[Object.keys(serverStates).find(serverKey =>
  window.location.hostname.toLowerCase().includes(serverStates[serverKey].lnk)
) || 'release']
